import { FieldType } from "../../constants";

export const datedMessageSetting = {
	fields: [
		[
			{
				field: "afterDate",
				title: "Start Date",
				type: FieldType.DATE,
				isMandatory: true,
			},
		],
		[
			{
				field: "beforeDate",
				title: "End Date",
				type: FieldType.DATE,
				isMandatory: true,
			},
		],
		[
			{
				field: "translatedTitle",
				title: "Translated Title",
				type: FieldType.JSON_DICT,
				isMandatory: true,
				placeholder: ["Lang Code Here", "English (en) Title Here"],
				initialData: { en: "" },
			},
		],
		[
			{
				field: "translatedMessage",
				title: "Translated Message",
				type: FieldType.JSON_DICT,
				isMandatory: true,
				placeholder: [
					"Lang Code Here",
					"English (en) message content here...",
				],
				initialData: { en: "" },
			},
		],
	],
};

export const enforceMinVerSetting = {
	fields: [
		[
			{
				field: "warningMinimumVersion",
				title: "Warning Min. Version",
				isMandatory: true,
				placeholder: "YY.MM.DD.Commit",
			},
		],
		[
			{
				field: "criticalMinimumVersion",
				title: "Critical Min. Version",
				isMandatory: true,
				placeholder: "YY.MM.DD.Commit",
			},
		],
	],
};

export const datedIconSetting = {
	fields: [
		[
			{
				field: "startDate",
				title: "Start Date",
				type: FieldType.DATE,
				isMandatory: true,
			},
		],
		[
			{
				field: "endDate",
				title: "End Date",
				type: FieldType.DATE,
				isMandatory: true,
			},
		],
		[
			{
				field: "iconBase64",
				title: "Icon Base 64",
				type: FieldType.TEXT_AREA,
				isMandatory: true,
			},
		],
	],
};

export const datedButtonSetting = {
	fields: [
		[
			{
				field: "startDate",
				title: "Start Date",
				type: FieldType.DATE,
				isMandatory: true,
			},
		],
		[
			{
				field: "endDate",
				title: "End Date",
				type: FieldType.DATE,
				isMandatory: true,
			},
		],
		[
			{
				field: "iconBase64",
				title: "Icon Base 64",
				type: FieldType.TEXT_AREA,
				isMandatory: true,
			},
		],
		[
			{
				field: "caption",
				title: "Caption",
				type: FieldType.JSON_DICT,
				isMandatory: true,
				placeholder: ["Lang Code Here", "English (en) Caption Here"],
				initialData: { en: "" },
			},
		],
		[
			{
				field: "message",
				title: "Message",
				type: FieldType.JSON_DICT,
				isMandatory: true,
				placeholder: [
					"Lang Code Here",
					"English (en) message content here...",
				],
				initialData: { en: "" },
			},
		],
	],
};
